'use client';
import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';

type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  /** legacy prop name used elsewhere in the codebase */
  containerID?: string;
  /** preferred prop name (camelCase) - maps to the element id */
  containerId?: string;
  /** classes specific to the container element (do not confuse with Section classes) */
  containerClasses?: string;
  /** legacy shorthand used in some UI kit demos */
  classes?: string;
  className?: string;
};

const Container = ({
  containerID,
  containerId,
  containerClasses = '',
  classes = '',
  className = '',
  children,
  ...rest
}: ContainerProps) => {
  // prefer the explicit containerId prop, then the legacy containerID
  const id = containerId ?? containerID;
  // Always include 'container' class
  const cls = ['container'];
  // Accept several class inputs for compatibility: className, containerClasses, classes
  if (className) cls.push(className);
  if (containerClasses) cls.push(containerClasses);
  if (classes) cls.push(classes);
  return (
    <div {...withOptionalId(id)} className={cls.filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
};

export default Container;
